export enum EMCType {
  Building = 9,
}

export enum Purpose {
  ListPage = 0,
  Download = 1,
  Filter = 2,
  Edit = 3,
  Search = 4,
  Card = 5,
}

export enum SectionDefinitionEntityType {
  Building = 9,
  Customer = 23,
}

export enum DateType {
  LastUpdateTime = 2,
  TaggedDate = 3,
  ValidatedDate = 6,
  ReviewDate = 10,
}

export class PageInfo {
  page: number = 1;
  pageSize: number = 10;

  constructor(page: number = 1, pageSize: number = 10) {
    this.page = page;
    this.pageSize = pageSize;
  }
}

export class DynamicPropertiesFilter {
  attributeDefinitionId: number | null = null;
  selectedOptions: number[] = [];
  from: Date | null = null;
  to: Date | null = null;
}

export class EmcSearchOutput {
  attributeDefinitionId: number | null = null;
  staticPropertyName: string = '';
  searchValue: string = '';
}

export class SelectableItem {
  id: number = 0;
  name: string = '';
}

export class StaticFilter {
  sortBy: number = 1;
  search: string = '';
  filterBy: string = '';
  userType: number | null = null;
  dateFrom: string | null = null;
  dateTo: string | null = null;
  dateType: DateType = DateType.LastUpdateTime;
  tag: boolean | null = null;
  reviewStatus: boolean | null = null;
  selectedAreas: number[] = [];
  selectedRegions: number[] = [];
  selectedSubgeographicalRegions: number[] = [];
  selectedGeographicalRegions: number[] = [];
  selectedSubstations: number[] = [];
  selectedUsers: number[] = [];
  selectedIds: number[] = [];
  dtId: number | null = null;
  dtIds: number[] = [];
  validationStatuses: number[] = [];

  dateTypeString: string = 'Last Update Time';
  regionSearchText: string = '';
  areaSearchText: string = '';
  geoSearchText: string = '';
  subGeoSearchText: string = '';
  searchUsersText: string = '';
  selectedUserTypeString: string | null = null;
  selectedRegionModel: SelectableItem | null = null;
  selectedGeoRegionModel: SelectableItem | null = null;
  selectedAreaModels: SelectableItem[] = [];
  selectedSubGeoModels: SelectableItem[] = [];
  selectedUserModels: SelectableItem[] = [];
  sortByName: string = 'Newest';
}

export class DynamicBuildingFilter {
  pageInfo: PageInfo = new PageInfo();
  filterParams: StaticFilter = new StaticFilter();
  dynamicFilters: DynamicPropertiesFilter[] = [];
  searchObject: EmcSearchOutput = new EmcSearchOutput();
  utilityId: number = 0;
}

export class AdditionalStatsInfo {
  propertyName: string = '';
  optionIds: number[] = [];
}

export class EmcOptions {
  id: number = 0;
  labelName: string = '';
  attributeDefinitionId: number | null = null;
  staticPropertyName: string | null = null;
  displayOrder: number = 0;
  additionalStatsInfo: AdditionalStatsInfo | null = null;
}

export class HeaderRow {
  name: string = '';
}

export class TableContentCell {
  valueType: string = '';
  stringValue?: string;
  intValue?: number;
  dateTimeValue?: string;
  boolValue?: boolean;
}

export class TableContentRow {
  guid: string = '';
  data: TableContentCell[] = [];
}

export class TableListPage {
  headers: HeaderRow[] = [];
  rows: TableContentRow[] = [];
  count: number | null = 0;
}
